<script setup lang="ts" generic="T">
import type { RouteLocationRaw } from "vue-router";

const props = defineProps<{
  title: string;
  items: T[];
  itemKey?: (item: T, index: number) => string | number;
  seeAllTo?: RouteLocationRaw;
  seeAllLabel?: string;
}>();

defineSlots<{
  default(props: { item: T; index: number }): unknown;
}>();
</script>

<template>
  <div v-if="props.items.length">
    <div class="flex flex-wrap items-center justify-between gap-x-4 gap-y-6 mb-10">
      <h2 class="text-3xl lg:text-4xl font-semibold">{{ props.title }}</h2>
      <UButton v-if="props.seeAllTo" :to="props.seeAllTo" variant="outline">{{ props.seeAllLabel }}</UButton>
    </div>

    <AppCarouselTiles
      :items="props.items"
      :item-key="props.itemKey"
      :label="props.title"
      class="[--carousel-vertical-gap:--spacing(14)]"
      overflow-visible
    >
      <template #default="slotProps">
        <slot v-bind="slotProps" />
      </template>
    </AppCarouselTiles>
  </div>
</template>
